/**
 * Sentences in Catalan have a similar length distribution as in Spanish, so use the same 25 word limit. For a more detailed explanation, see:
 * https://github.com/Yoast/research/wiki/Sentence-Length-Catalan
 */

export default {
	sentenceLength: {
		recommendedWordCount: 25,
	},
};
